<template>
    <g fill="none" fill-rule="evenodd">
        <g fill-rule="nonzero">
            <g>
                <path fill="#678099" d="M10.938 7.875H9.363V3.937c0-.393-.158-2.362-2.363-2.362S4.638 3.544 4.638 3.937v3.938H3.063V3.937C3.063 2.6 3.85 0 7 0s3.938 2.599 3.938 3.938v3.937z" transform="translate(-594 -431) translate(594 431)"/>
                <path fill="#C2CDD7" d="M12.425 16H1.575C.7 16 0 15.333 0 14.5v-7C0 6.667.7 6 1.575 6h10.85C13.3 6 14 6.667 14 7.5v7c0 .833-.7 1.5-1.575 1.5" transform="translate(-594 -431) translate(594 431)"/>
                <path fill="#678099" d="M9 11c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2" transform="translate(-594 -431) translate(594 431)"/>
            </g>
        </g>
    </g>
</template>

<script>
export default {
    name: 'lockAppIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 14 16');
    }
};
</script>
